import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  colors: {
    cardAccentColor: string
    textAccentColor: string
  }
}

const stylesEstatistic = makeStyles<Theme, StyleProps>((theme) => ({
  main: (props) => ({
    width: '100%',
    padding: '80px 10px',
    display: 'flex',
    justifyContent: 'center',
    background: `linear-gradient(180deg, ${props.colors.cardAccentColor} 0%, ${props.colors.cardAccentColor} 100%)`,
    alignItems: 'center',
  }),
  textTitle: (props) => ({
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    padding: '10px 0px 0px 3px',
    fontWeight: 'bold',
    color: props.colors.textAccentColor,
    left: 9,
    bottom: 40,
    '&::after': {
      content: '""',
      display: 'block',
      width: 4,
      height: 24,
      backgroundColor: props.colors.textAccentColor,
      position: 'absolute',
      bottom: 6,
      marginLeft: -14,
      left: 5,
    },
  }),
  line: (props) => ({
    width: 2,
    height: 40,
    backgroundColor: props.colors.textAccentColor,
    marginLeft: 4,
    marginRight: 4,
  }),
}))

export default stylesEstatistic
